import styled, { css } from 'styled-components';
import Button from '@CS/components/Button/Button.styles';

const SMALL_HEIGHT = 667;

export const SurvivalContainer = styled.div`
  padding: min(9.3vmin, 35px) 1rem min(11.2vmin, 42px);
  background-color: rgb(255 255 255);

  background-clip: content-box;
  justify-content: flex-start;

  flex-direction: column;
  align-content: center;
  align-items: center;

  position: relative;
  flex-wrap: nowrap;
  overflow: hidden;

  display: flex;
  height: auto;
  width: 100%;
`;

type SurvivalTitleAttributes = {
  small?: boolean;
};

export const SurvivalTitle = styled.h3<SurvivalTitleAttributes>(
  ({ small }) => css`
    text-transform: uppercase;
    margin-bottom: 1rem;
    font-size: 1.75rem;

    line-height: 1.125;
    text-align: center;
    position: relative;
    color: rgb(0 0 0);

    display: block;
    height: auto;
    width: 100%;

    ${small &&
    css`
      font-size: 1.5rem;
    `}

    @media (max-height: ${SMALL_HEIGHT}px) {
      font-size: 1.5rem;
      max-width: 225px;

      ${small &&
      css`
        font-size: 1.25rem;
      `}
    }
  `
);

export const SurvivalDescription = styled.p`
  margin: 0.75rem auto 1.5rem;
  line-height: 1.25rem;
  color: rgb(34 34 34);
  text-align: center;

  position: relative;
  padding: 0 0.5rem;
  font-size: 1rem;

  display: block;
  height: auto;
  width: 100%;

  @media (max-height: ${SMALL_HEIGHT}px) {
    margin-bottom: 0.25rem;
  }
`;

export const SurvivalBalance = styled.label`
  line-height: 1.25rem;
  font-size: 0.75rem;

  text-align: center;
  color: rgb(0 0 0);
  display: block;
`;

export const SurvivalPoints = styled.em`
  line-height: 1.25rem;
  margin: 0 auto 1rem;

  font-style: normal;
  text-align: center;
  position: relative;

  font-size: 1rem;
  display: block;

  @media (max-height: ${SMALL_HEIGHT}px) {
    margin-bottom: 0.25rem;
  }

  > svg {
    margin-right: 0.5rem;
    height: 1.125rem;
    width: 17px;
  }
`;

export const SurvivalCancelButton = styled(Button)`
  margin-top: 1rem;
`;
